import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { AuthQuery } from '@app/auth/auth.query';
import { roleBadgeClasses, roleBadgeLabel } from '@app/@shared/roles';
import { DashboardService, DashboardStats } from '@app/services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  showZahlungsabgleich = environment.showZahlungsabgleich;

  stats: DashboardStats | null = null;
  loadingStats = false;
  statsError = '';

  constructor(private authQuery: AuthQuery, private dashboardService: DashboardService) {}

  get isSuperuser(): boolean {
    return this.authQuery.isSuperuser;
  }

  get canSeeTransfer(): boolean {
    return this.authQuery.can('transfer');
  }

  get canSeeMandate(): boolean {
    return this.authQuery.can('mandate');
  }

  get canSeeZahlung(): boolean {
    return this.showZahlungsabgleich && this.authQuery.can('zahlungsabgleich');
  }

  get canSeeVstv(): boolean {
    return this.authQuery.can('vstv');
  }

  ngOnInit(): void {
    if (this.isSuperuser) {
      this.loadStats();
    }
  }

  loadStats(): void {
    this.loadingStats = true;
    this.statsError = '';
    this.dashboardService.getStats().subscribe(
      (data) => {
        this.stats = {
          ...data,
          dienstnehmer: data.dienstnehmer ?? [],
        };
        this.loadingStats = false;
      },
      () => {
        this.statsError = 'Statistiken konnten nicht geladen werden.';
        this.loadingStats = false;
      }
    );
  }

  roleLabel(roleId: number): string {
    return roleBadgeLabel(roleId);
  }

  roleClasses(roleId: number): string {
    return roleBadgeClasses(roleId);
  }
}
